import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface MobileInstructionsProps {
  onOpenConsultation: () => void;
}

export function MobileInstructions({ onOpenConsultation }: MobileInstructionsProps) {
  const { t } = useTranslation('application');

  return (
    <div className="bg-[#FFF5F2] border border-[#FFD4C7] p-6">
      <h4 className="font-bold text-[18px] mb-4">{t('instructions.title')}</h4>
      
      <p className="text-[16px] mb-4">
        {t('instructions.description')}
      </p>
      
      <button
        onClick={onOpenConsultation}
        className="w-full bg-[#FF6F4E] text-black hover:bg-[#FF6F4E]/90 px-4 font-bold text-[16px] inline-flex items-center justify-center gap-2 transition-colors min-h-[48px]"
      >
        <ExternalLink className="w-4 h-4" />
        {t('instructions.openConsultation')}
      </button>
    </div>
  );
}

